export default __webpack_public_path__ + "static/media/pin.476fc85c.svg";